import { TextSize, TextStyle, TextWeight } from '@vw-marketing/us-components';
import { FeatureAppTrackingEvent } from '../../hooks/use-tracking-manager';

export const videoTitleMobileStyle: TextStyle = {
  fontSize: TextSize.TextSize20,
  fontWeight: TextWeight.bold,
};

export const videoTitleStyle: TextStyle = {
  fontSize: TextSize.TextSize28,
  fontWeight: TextWeight.bold,
};

export const videoBodyMobileStyle: TextStyle = {
  fontSize: TextSize.TextSize16,
};

export const videoBodyStyle: TextStyle = {
  fontSize: TextSize.TextSize14,
};

export const numberMobileTextStyle: TextStyle = {
  fontSize: TextSize.TextSize12,
  fontWeight: TextWeight.bold,
};

export const numberTextStyle: TextStyle = {
  fontSize: TextSize.TextSize14,
  fontWeight: TextWeight.bold,
};

const recordPercentage = (e: any, onVideoMilestoneReached: Function) => {
  if (e?.target?.getCurrentTime() < e?.target?.getDuration()) {
    const percentage = Math.round(
      (e?.target?.getCurrentTime() / e?.target?.getDuration()) * 100,
    );
    checkIfMilestoneReached(percentage, onVideoMilestoneReached, e);
  }
};

const checkIfMilestoneReached = (
  percentage: number,
  onVideoMilestoneReached: Function,
  e: any,
) => {
  let videoInfo = getVideoInformation(e);
  if (percentage >= 10 && percentage < 25) {
    predefinedMilestone[10] === false && onVideoMilestoneReached(10, videoInfo);
    predefinedMilestone[10] = true;
  } else if (percentage >= 25 && percentage < 50) {
    predefinedMilestone[25] === false && onVideoMilestoneReached(25, videoInfo);
    predefinedMilestone[25] = true;
  } else if (percentage >= 50 && percentage < 75) {
    predefinedMilestone[50] === false && onVideoMilestoneReached(50, videoInfo);
    predefinedMilestone[50] = true;
  } else if (percentage >= 75 && percentage < 90) {
    predefinedMilestone[75] === false && onVideoMilestoneReached(75, videoInfo);
    predefinedMilestone[75] = true;
  } else if (percentage >= 90 && percentage < 100) {
    predefinedMilestone[90] === false && onVideoMilestoneReached(90, videoInfo);
    predefinedMilestone[90] = true;
  }
};

interface PredefinedMilestone {
  10: boolean;
  25: boolean;
  50: boolean;
  75: boolean;
  90: boolean;
}

const defaultPredefinedMilestone: PredefinedMilestone = {
  10: false,
  25: false,
  50: false,
  75: false,
  90: false,
};

let predefinedMilestone: PredefinedMilestone = JSON.parse(
  JSON.stringify(defaultPredefinedMilestone),
);
let timer: number;
export const trackVideoMilestone = (
  e: any,
  onVideoMilestoneReached: Function,
) => {
  if (e.data === -1) {
    predefinedMilestone = JSON.parse(
      JSON.stringify(defaultPredefinedMilestone),
    );
  }
  if (e.data === 0) {
    onVideoMilestoneReached &&
      onVideoMilestoneReached(100, getVideoInformation(e));
    clearInterval(timer);
    predefinedMilestone = JSON.parse(
      JSON.stringify(defaultPredefinedMilestone),
    );
  } else if (e.data === 1) {
    const videoInterval = Math.round((e?.target?.getDuration() / 60) * 1000);
    timer = setInterval(
      recordPercentage,
      videoInterval,
      e,
      onVideoMilestoneReached,
    );
  } else {
    clearInterval(timer);
  }
};

export const getVideoInformation = (
  e: any,
): FeatureAppTrackingEvent['video'] => {
  return {
    playerName: 'YouTube Player',
    title: e.target.getVideoData().title,
    id: e.target.getVideoData().video_id,
    platform: 'YouTube',
    url: e.target.getVideoUrl(),
    timeplayed: e.target.getCurrentTime(),
    length: e.target.getDuration(),
    playReason: 'user click',
    viewable: e.target.getVideoData().isPlayable,
    resoltion: e.target.getPlaybackQuality(),
  };
};
